import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import bulletsMenuHOC from '../../common/bulletsMenuHOC';
import MenuListButton from '../../common/ui/MenuListButton';
import UsersService from '../../../services/UsersService';
import { isJobHasNotStarted, isJobPosted, isJobSaved } from '../../../helpers/jobs';

class SettingsMenu extends Component {
  static propTypes = {
    jobDetails: PropTypes.object,
    postJob: PropTypes.func.isRequired,
    cancelJob: PropTypes.func.isRequired,
    closeMenu: PropTypes.func.isRequired
  };

  postJob = (postToBoard, needSwitchToWorkers = false) => {
    this.props.postJob(postToBoard, needSwitchToWorkers);
    this.props.closeMenu();
  };

  cancelJob = () => {
    this.props.closeMenu();
    this.props.cancelJob();
  };

  render () {
    const { is_post_to_board, start_date, time_zone_id, status } = this.props.jobDetails;
    const jobStatusIsSaved = isJobSaved(status);
    const jobStatusIsPosted = isJobPosted(status);
    const jobHasNotStarted = isJobHasNotStarted(start_date, time_zone_id);
    const isPostToBoardAllowed = jobHasNotStarted && (jobStatusIsSaved || jobStatusIsPosted);
    const isPostChooseWorkersAllowed = (jobHasNotStarted || UsersService.isAdmin()) && jobStatusIsSaved;
    return (
      <ul className='popupMenu settings-menu'>
        { isPostToBoardAllowed && (
          <Fragment>
            { is_post_to_board ? (
              <MenuListButton onClick={() => this.postJob(false)} name='Remove from Job Board' />
            ) : (
              <MenuListButton onClick={() => this.postJob(true)} name='Post to Job Board' />
            )}
          </Fragment>
        )}
        { isPostChooseWorkersAllowed && (
          <MenuListButton onClick={() => this.postJob(false, true)} name='Post and Choose Workers' />
        )}
        <MenuListButton onClick={this.cancelJob} name='Cancel this job' className='cancel' />
      </ul>
    );
  }
}

export default bulletsMenuHOC(SettingsMenu);



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/SettingsMenu.js